export const COUNTRY_LIST: Array<any> = [
  {
    name: 'United States',
    abbreviation: 'US',
    timezone: 'Pacific Standard Time',
    utc: 'UTC-08:00',
    code: '+1',
  },
  {
    name: 'Afghanistan',
    abbreviation: 'AF',
    timezone: 'Afghanistan Standard Time',
    utc: 'UTC+04:30',
    code: '+93',
  },
  {
    name: 'Åland Islands',
    abbreviation: 'AX',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+358-18',
  },
  {
    name: 'Albania',
    abbreviation: 'AL',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+355',
  },
  {
    name: 'Algeria',
    abbreviation: 'DZ',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+213',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
    timezone: 'UTC-11',
    utc: 'UTC-11:00',
    code: '+1-684',
  },
  {
    name: 'Andorra',
    abbreviation: 'AD',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+376',
  },
  {
    name: 'Angola',
    abbreviation: 'AO',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+244',
  },
  {
    name: 'Anguilla',
    abbreviation: 'AI',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-264',
  },
  {
    name: 'Antarctica',
    abbreviation: 'AQ',
    timezone: 'Pacific SA Standard Time',
    utc: 'UTC-03:00',
    code: '+',
  },
  {
    name: 'Antigua and Barbuda',
    abbreviation: 'AG',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-268',
  },
  {
    name: 'Argentina',
    abbreviation: 'AR',
    timezone: 'Argentina Standard Time',
    utc: 'UTC-03:00',
    code: '+54',
  },
  {
    name: 'Armenia',
    abbreviation: 'AM',
    timezone: 'Caucasus Standard Time',
    utc: 'UTC+04:00',
    code: '+374',
  },
  {
    name: 'Aruba',
    abbreviation: 'AW',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+297',
  },
  {
    name: 'Australia',
    abbreviation: 'AU',
    timezone: 'AUS Eastern Standard Time',
    utc: 'UTC+10:00',
    code: '+61',
  },
  {
    name: 'Austria',
    abbreviation: 'AT',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+43',
  },
  {
    name: 'Azerbaijan',
    abbreviation: 'AZ',
    timezone: 'Azerbaijan Standard Time',
    utc: 'UTC+04:00',
    code: '+994',
  },
  {
    name: 'Bahamas, The',
    abbreviation: 'BS',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    code: '+1-242',
  },
  {
    name: 'Bahrain',
    abbreviation: 'BH',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    code: '+973',
  },
  {
    name: 'Bangladesh',
    abbreviation: 'BD',
    timezone: 'Bangladesh Standard Time',
    utc: 'UTC+06:00',
    code: '+880',
  },
  {
    name: 'Barbados',
    abbreviation: 'BB',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-246',
  },
  {
    name: 'Belarus',
    abbreviation: 'BY',
    timezone: 'Belarus Standard Time',
    utc: 'UTC+03:00',
    code: '+375',
  },
  {
    name: 'Belgium',
    abbreviation: 'BE',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    code: '+32',
  },
  {
    name: 'Belize',
    abbreviation: 'BZ',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    code: '+501',
  },
  {
    name: 'Benin',
    abbreviation: 'BJ',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+229',
  },
  {
    name: 'Bermuda',
    abbreviation: 'BM',
    timezone: 'Atlantic Standard Time',
    utc: 'UTC-04:00',
    code: '+1-441',
  },
  {
    name: 'Bhutan',
    abbreviation: 'BT',
    timezone: 'Bangladesh Standard Time',
    utc: 'UTC+06:00',
    code: '+975',
  },
  {
    name: 'Bolivarian Republic of Venezuela',
    abbreviation: 'VE',
    timezone: 'Venezuela Standard Time',
    utc: 'UTC-04:30',
    code: '+58',
  },
  {
    name: 'Bolivia',
    abbreviation: 'BO',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+591',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    abbreviation: 'BQ',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+599',
  },
  {
    name: 'Bosnia and Herzegovina',
    abbreviation: 'BA',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    code: '+387',
  },
  {
    name: 'Botswana',
    abbreviation: 'BW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+267',
  },
  {
    name: 'Bouvet Island',
    abbreviation: 'BV',
    timezone: 'UTC',
    utc: 'UTC',
    code: '+',
  },
  {
    name: 'Brazil',
    abbreviation: 'BR',
    timezone: 'E. South America Standard Time',
    utc: 'UTC-03:00',
    code: '+55',
  },
  {
    name: 'British Indian Ocean Territory',
    abbreviation: 'IO',
    timezone: 'Central Asia Standard Time',
    utc: 'UTC+06:00',
    code: '+246',
  },
  {
    name: 'Brunei',
    abbreviation: 'BN',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    code: '+673',
  },
  {
    name: 'Bulgaria',
    abbreviation: 'BG',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+359',
  },
  {
    name: 'Burkina Faso',
    abbreviation: 'BF',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+226',
  },
  {
    name: 'Burundi',
    abbreviation: 'BI',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+257',
  },
  {
    name: 'Cabo Verde',
    abbreviation: 'CV',
    timezone: 'Cape Verde Standard Time',
    utc: 'UTC-01:00',
    code: '+238',
  },
  {
    name: 'Cambodia',
    abbreviation: 'KH',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    code: '+855',
  },
  {
    name: 'Cameroon',
    abbreviation: 'CM',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+237',
  },
  {
    name: 'Canada',
    abbreviation: 'CA',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    code: '+1',
  },
  {
    name: 'Cayman Islands',
    abbreviation: 'KY',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    code: '+1-345',
  },
  {
    name: 'Central African Republic',
    abbreviation: 'CF',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+236',
  },
  {
    name: 'Chad',
    abbreviation: 'TD',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+235',
  },
  {
    name: 'Chile',
    abbreviation: 'CL',
    timezone: 'Pacific SA Standard Time',
    utc: 'UTC-03:00',
    code: '+56',
  },
  {
    name: 'China',
    abbreviation: 'CN',
    timezone: 'China Standard Time',
    utc: 'UTC+08:00',
    code: '+86',
  },
  {
    name: 'Christmas Island',
    abbreviation: 'CX',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    code: '+61',
  },
  {
    name: 'Cocos (Keeling) Islands',
    abbreviation: 'CC',
    timezone: 'Myanmar Standard Time',
    utc: 'UTC+06:30',
    code: '+61',
  },
  {
    name: 'Colombia',
    abbreviation: 'CO',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    code: '+57',
  },
  {
    name: 'Comoros',
    abbreviation: 'KM',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+269',
  },
  {
    name: 'Congo',
    abbreviation: 'CG',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+242',
  },
  {
    name: 'Congo (DRC)',
    abbreviation: 'CD',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+243',
  },
  {
    name: 'Cook Islands',
    abbreviation: 'CK',
    timezone: 'Hawaiian Standard Time',
    utc: 'UTC-10:00',
    code: '+682',
  },
  {
    name: 'Costa Rica',
    abbreviation: 'CR',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    code: '+506',
  },
  {
    name: "Côte d'Ivoire",
    abbreviation: 'CI',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+225',
  },
  {
    name: 'Croatia',
    abbreviation: 'HR',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    code: '+385',
  },
  {
    name: 'Cuba',
    abbreviation: 'CU',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    code: '+53',
  },
  {
    name: 'Curaçao',
    abbreviation: 'CW',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+599',
  },
  {
    name: 'Cyprus',
    abbreviation: 'CY',
    timezone: 'E. Europe Standard Time',
    utc: 'UTC+02:00',
    code: '+357',
  },
  {
    name: 'Czech Republic',
    abbreviation: 'CZ',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+420',
  },
  {
    name: 'Democratic Republic of Timor-Leste',
    abbreviation: 'TL',
    timezone: 'Tokyo Standard Time',
    utc: 'UTC+09:00',
    code: '+670',
  },
  {
    name: 'Denmark',
    abbreviation: 'DK',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    code: '+45',
  },
  {
    name: 'Djibouti',
    abbreviation: 'DJ',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+253',
  },
  {
    name: 'Dominica',
    abbreviation: 'DM',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-767',
  },
  {
    name: 'Dominican Republic',
    abbreviation: 'DO',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-809 and 1-829',
  },
  {
    name: 'Ecuador',
    abbreviation: 'EC',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    code: '+593',
  },
  {
    name: 'Egypt',
    abbreviation: 'EG',
    timezone: 'Egypt Standard Time',
    utc: 'UTC+02:00',
    code: '+20',
  },
  {
    name: 'El Salvador',
    abbreviation: 'SV',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    code: '+503',
  },
  {
    name: 'Equatorial Guinea',
    abbreviation: 'GQ',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+240',
  },
  {
    name: 'Eritrea',
    abbreviation: 'ER',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+291',
  },
  {
    name: 'Estonia',
    abbreviation: 'EE',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+372',
  },
  {
    name: 'Ethiopia',
    abbreviation: 'ET',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+251',
  },
  {
    name: 'Falkland Islands (Islas Malvinas)',
    abbreviation: 'FK',
    timezone: 'SA Eastern Standard Time',
    utc: 'UTC-03:00',
    code: '+500',
  },
  {
    name: 'Faroe Islands',
    abbreviation: 'FO',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+298',
  },
  {
    name: 'Fiji Islands',
    abbreviation: 'FJ',
    timezone: 'Fiji Standard Time',
    utc: 'UTC+12:00',
    code: '+679',
  },
  {
    name: 'Finland',
    abbreviation: 'FI',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+358',
  },
  {
    name: 'France',
    abbreviation: 'FR',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    code: '+33',
  },
  {
    name: 'French Guiana',
    abbreviation: 'GF',
    timezone: 'SA Eastern Standard Time',
    utc: 'UTC-03:00',
    code: '+594',
  },
  {
    name: 'French Polynesia',
    abbreviation: 'PF',
    timezone: 'Hawaiian Standard Time',
    utc: 'UTC-10:00',
    code: '+689',
  },
  {
    name: 'French Southern and Antarctic Lands',
    abbreviation: 'TF',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    code: '+',
  },
  {
    name: 'Gabon',
    abbreviation: 'GA',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+241',
  },
  {
    name: 'Gambia, The',
    abbreviation: 'GM',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+220',
  },
  {
    name: 'Georgia',
    abbreviation: 'GE',
    timezone: 'Georgian Standard Time',
    utc: 'UTC+04:00',
    code: '+995',
  },
  {
    name: 'Germany',
    abbreviation: 'DE',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+49',
  },
  {
    name: 'Ghana',
    abbreviation: 'GH',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+233',
  },
  {
    name: 'Gibraltar',
    abbreviation: 'GI',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+350',
  },
  {
    name: 'Greece',
    abbreviation: 'GR',
    timezone: 'GTB Standard Time',
    utc: 'UTC+02:00',
    code: '+30',
  },
  {
    name: 'Greenland',
    abbreviation: 'GL',
    timezone: 'Greenland Standard Time',
    utc: 'UTC-03:00',
    code: '+299',
  },
  {
    name: 'Grenada',
    abbreviation: 'GD',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-473',
  },
  {
    name: 'Guadeloupe',
    abbreviation: 'GP',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+590',
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    code: '+1-671',
  },
  {
    name: 'Guatemala',
    abbreviation: 'GT',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    code: '+502',
  },
  {
    name: 'Guernsey',
    abbreviation: 'GG',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+44-1481',
  },
  {
    name: 'Guinea',
    abbreviation: 'GN',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+224',
  },
  {
    name: 'Guinea-Bissau',
    abbreviation: 'GW',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+245',
  },
  {
    name: 'Guyana',
    abbreviation: 'GY',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+592',
  },
  {
    name: 'Haiti',
    abbreviation: 'HT',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    code: '+509',
  },
  {
    name: 'Heard Island and McDonald Islands',
    abbreviation: 'HM',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    code: '+ ',
  },
  {
    name: 'Honduras',
    abbreviation: 'HN',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    code: '+504',
  },
  {
    name: 'Hong Kong SAR',
    abbreviation: 'HK',
    timezone: 'China Standard Time',
    utc: 'UTC+08:00',
    code: '+852',
  },
  {
    name: 'Hungary',
    abbreviation: 'HU',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+36',
  },
  {
    name: 'Iceland',
    abbreviation: 'IS',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+354',
  },
  {
    name: 'India',
    abbreviation: 'IN',
    timezone: 'India Standard Time',
    utc: 'UTC+05:30',
    code: '+91',
  },
  {
    name: 'Indonesia',
    abbreviation: 'ID',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    code: '+62',
  },
  {
    name: 'Iran',
    abbreviation: 'IR',
    timezone: 'Iran Standard Time',
    utc: 'UTC+03:30',
    code: '+98',
  },
  {
    name: 'Iraq',
    abbreviation: 'IQ',
    timezone: 'Arabic Standard Time',
    utc: 'UTC+03:00',
    code: '+964',
  },
  {
    name: 'Ireland',
    abbreviation: 'IE',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+353',
  },
  {
    name: 'Israel',
    abbreviation: 'IL',
    timezone: 'Israel Standard Time',
    utc: 'UTC+02:00',
    code: '+972',
  },
  {
    name: 'Italy',
    abbreviation: 'IT',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+39',
  },
  {
    name: 'Jamaica',
    abbreviation: 'JM',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    code: '+1-876',
  },
  {
    name: 'Jan Mayen',
    abbreviation: 'SJ',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+47',
  },
  {
    name: 'Japan',
    abbreviation: 'JP',
    timezone: 'Tokyo Standard Time',
    utc: 'UTC+09:00',
    code: '+81',
  },
  {
    name: 'Jersey',
    abbreviation: 'JE',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+44-1534',
  },
  {
    name: 'Jordan',
    abbreviation: 'JO',
    timezone: 'Jordan Standard Time',
    utc: 'UTC+02:00',
    code: '+962',
  },
  {
    name: 'Kazakhstan',
    abbreviation: 'KZ',
    timezone: 'Central Asia Standard Time',
    utc: 'UTC+06:00',
    code: '+7',
  },
  {
    name: 'Kenya',
    abbreviation: 'KE',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+254',
  },
  {
    name: 'Kiribati',
    abbreviation: 'KI',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    code: '+686',
  },
  {
    name: 'Korea',
    abbreviation: 'KR',
    timezone: 'Korea Standard Time',
    utc: 'UTC+09:00',
    code: '+82',
  },
  {
    name: 'Kosovo',
    abbreviation: 'XK',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    code: '+',
  },
  {
    name: 'Kuwait',
    abbreviation: 'KW',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    code: '+965',
  },
  {
    name: 'Kyrgyzstan',
    abbreviation: 'KG',
    timezone: 'Central Asia Standard Time',
    utc: 'UTC+06:00',
    code: '+996',
  },
  {
    name: 'Laos',
    abbreviation: 'LA',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    code: '+856',
  },
  {
    name: 'Latvia',
    abbreviation: 'LV',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+371',
  },
  {
    name: 'Lebanon',
    abbreviation: 'LB',
    timezone: 'Middle East Standard Time',
    utc: 'UTC+02:00',
    code: '+961',
  },
  {
    name: 'Lesotho',
    abbreviation: 'LS',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+266',
  },
  {
    name: 'Liberia',
    abbreviation: 'LR',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+231',
  },
  {
    name: 'Libya',
    abbreviation: 'LY',
    timezone: 'E. Europe Standard Time',
    utc: 'UTC+02:00',
    code: '+218',
  },
  {
    name: 'Liechtenstein',
    abbreviation: 'LI',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+423',
  },
  {
    name: 'Lithuania',
    abbreviation: 'LT',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+370',
  },
  {
    name: 'Luxembourg',
    abbreviation: 'LU',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+352',
  },
  {
    name: 'Macao SAR',
    abbreviation: 'MO',
    timezone: 'China Standard Time',
    utc: 'UTC+08:00',
    code: '+853',
  },
  {
    name: 'Macedonia, Former Yugoslav Republic of',
    abbreviation: 'MK',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    code: '+389',
  },
  {
    name: 'Madagascar',
    abbreviation: 'MG',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+261',
  },
  {
    name: 'Malawi',
    abbreviation: 'MW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+265',
  },
  {
    name: 'Malaysia',
    abbreviation: 'MY',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    code: '+60',
  },
  {
    name: 'Maldives',
    abbreviation: 'MV',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    code: '+960',
  },
  {
    name: 'Mali',
    abbreviation: 'ML',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+223',
  },
  {
    name: 'Malta',
    abbreviation: 'MT',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+356',
  },
  {
    name: 'Man, Isle of',
    abbreviation: 'IM',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+44-1624',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    code: '+692',
  },
  {
    name: 'Martinique',
    abbreviation: 'MQ',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+596',
  },
  {
    name: 'Mauritania',
    abbreviation: 'MR',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+222',
  },
  {
    name: 'Mauritius',
    abbreviation: 'MU',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    code: '+230',
  },
  {
    name: 'Mayotte',
    abbreviation: 'YT',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+262',
  },
  {
    name: 'Mexico',
    abbreviation: 'MX',
    timezone: 'Central Standard Time (Mexico)',
    utc: 'UTC-06:00',
    code: '+52',
  },
  {
    name: 'Micronesia',
    abbreviation: 'FM',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    code: '+691',
  },
  {
    name: 'Moldova',
    abbreviation: 'MD',
    timezone: 'GTB Standard Time',
    utc: 'UTC+02:00',
    code: '+373',
  },
  {
    name: 'Monaco',
    abbreviation: 'MC',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+377',
  },
  {
    name: 'Mongolia',
    abbreviation: 'MN',
    timezone: 'Ulaanbaatar Standard Time',
    utc: 'UTC+08:00',
    code: '+976',
  },
  {
    name: 'Montenegro',
    abbreviation: 'ME',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    code: '+382',
  },
  {
    name: 'Montserrat',
    abbreviation: 'MS',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-664',
  },
  {
    name: 'Morocco',
    abbreviation: 'MA',
    timezone: 'Morocco Standard Time',
    utc: 'UTC',
    code: '+212',
  },
  {
    name: 'Mozambique',
    abbreviation: 'MZ',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+258',
  },
  {
    name: 'Myanmar',
    abbreviation: 'MM',
    timezone: 'Myanmar Standard Time',
    utc: 'UTC+06:30',
    code: '+95',
  },
  {
    name: 'Namibia',
    abbreviation: 'NA',
    timezone: 'Namibia Standard Time',
    utc: 'UTC+01:00',
    code: '+264',
  },
  {
    name: 'Nauru',
    abbreviation: 'NR',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    code: '+674',
  },
  {
    name: 'Nepal',
    abbreviation: 'NP',
    timezone: 'Nepal Standard Time',
    utc: 'UTC+05:45',
    code: '+977',
  },
  {
    name: 'Netherlands',
    abbreviation: 'NL',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+31',
  },
  {
    name: 'New Caledonia',
    abbreviation: 'NC',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    code: '+687',
  },
  {
    name: 'New Zealand',
    abbreviation: 'NZ',
    timezone: 'New Zealand Standard Time',
    utc: 'UTC+12:00',
    code: '+64',
  },
  {
    name: 'Nicaragua',
    abbreviation: 'NI',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    code: '+505',
  },
  {
    name: 'Niger',
    abbreviation: 'NE',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+227',
  },
  {
    name: 'Nigeria',
    abbreviation: 'NG',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+234',
  },
  {
    name: 'Niue',
    abbreviation: 'NU',
    timezone: 'UTC-11',
    utc: 'UTC-11:00',
    code: '+683',
  },
  {
    name: 'Norfolk Island',
    abbreviation: 'NF',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    code: '+672',
  },
  {
    name: 'North Korea',
    abbreviation: 'KP',
    timezone: 'Korea Standard Time',
    utc: 'UTC+09:00',
    code: '+850',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    code: '+1-670',
  },
  {
    name: 'Norway',
    abbreviation: 'NO',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+47',
  },
  {
    name: 'Oman',
    abbreviation: 'OM',
    timezone: 'Arabian Standard Time',
    utc: 'UTC+04:00',
    code: '+968',
  },
  {
    name: 'Pakistan',
    abbreviation: 'PK',
    timezone: 'Pakistan Standard Time',
    utc: 'UTC+05:00',
    code: '+92',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
    timezone: 'Tokyo Standard Time',
    utc: 'UTC+09:00',
    code: '+680',
  },
  {
    name: 'Palestinian Authority',
    abbreviation: 'PS',
    timezone: 'Egypt Standard Time',
    utc: 'UTC+02:00',
    code: '+970',
  },
  {
    name: 'Panama',
    abbreviation: 'PA',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    code: '+507',
  },
  {
    name: 'Papua New Guinea',
    abbreviation: 'PG',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    code: '+675',
  },
  {
    name: 'Paraguay',
    abbreviation: 'PY',
    timezone: 'Paraguay Standard Time',
    utc: 'UTC-04:00',
    code: '+595',
  },
  {
    name: 'Peru',
    abbreviation: 'PE',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    code: '+51',
  },
  {
    name: 'Philippines',
    abbreviation: 'PH',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    code: '+63',
  },
  {
    name: 'Pitcairn Islands',
    abbreviation: 'PN',
    timezone: 'Pacific Standard Time',
    utc: 'UTC-08:00',
    code: '+870',
  },
  {
    name: 'Poland',
    abbreviation: 'PL',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    code: '+48',
  },
  {
    name: 'Portugal',
    abbreviation: 'PT',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+351',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-787 and 1-939',
  },
  {
    name: 'Qatar',
    abbreviation: 'QA',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    code: '+974',
  },
  {
    name: 'Reunion',
    abbreviation: 'RE',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    code: '+262',
  },
  {
    name: 'Romania',
    abbreviation: 'RO',
    timezone: 'GTB Standard Time',
    utc: 'UTC+02:00',
    code: '+40',
  },
  {
    name: 'Russia',
    abbreviation: 'RU',
    timezone: 'Russian Standard Time',
    utc: 'UTC+03:00',
    code: '+7',
  },
  {
    name: 'Rwanda',
    abbreviation: 'RW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+250',
  },
  {
    name: 'Saint Barthélemy',
    abbreviation: 'BL',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+590',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    abbreviation: 'SH',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+290',
  },
  {
    name: 'Saint Kitts and Nevis',
    abbreviation: 'KN',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-869',
  },
  {
    name: 'Saint Lucia',
    abbreviation: 'LC',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-758',
  },
  {
    name: 'Saint Martin (French part)',
    abbreviation: 'MF',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+590',
  },
  {
    name: 'Saint Pierre and Miquelon',
    abbreviation: 'PM',
    timezone: 'Greenland Standard Time',
    utc: 'UTC-03:00',
    code: '+508',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    abbreviation: 'VC',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-784',
  },
  {
    name: 'Samoa',
    abbreviation: 'WS',
    timezone: 'Samoa Standard Time',
    utc: 'UTC+13:00',
    code: '+685',
  },
  {
    name: 'San Marino',
    abbreviation: 'SM',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+378',
  },
  {
    name: 'São Tomé and Príncipe',
    abbreviation: 'ST',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+239',
  },
  {
    name: 'Saudi Arabia',
    abbreviation: 'SA',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    code: '+966',
  },
  {
    name: 'Senegal',
    abbreviation: 'SN',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+221',
  },
  {
    name: 'Serbia',
    abbreviation: 'RS',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+381',
  },
  {
    name: 'Seychelles',
    abbreviation: 'SC',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    code: '+248',
  },
  {
    name: 'Sierra Leone',
    abbreviation: 'SL',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+232',
  },
  {
    name: 'Singapore',
    abbreviation: 'SG',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    code: '+65',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    abbreviation: 'SX',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+599',
  },
  {
    name: 'Slovakia',
    abbreviation: 'SK',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+421',
  },
  {
    name: 'Slovenia',
    abbreviation: 'SI',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+386',
  },
  {
    name: 'Solomon Islands',
    abbreviation: 'SB',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    code: '+677',
  },
  {
    name: 'Somalia',
    abbreviation: 'SO',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+252',
  },
  {
    name: 'South Africa',
    abbreviation: 'ZA',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+27',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    abbreviation: 'GS',
    timezone: 'UTC-02',
    utc: 'UTC-02:00',
    code: '+',
  },
  {
    name: 'South Sudan',
    abbreviation: 'SS',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+211',
  },
  {
    name: 'Spain',
    abbreviation: 'ES',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    code: '+34',
  },
  {
    name: 'Sri Lanka',
    abbreviation: 'LK',
    timezone: 'Sri Lanka Standard Time',
    utc: 'UTC+05:30',
    code: '+94',
  },
  {
    name: 'Sudan',
    abbreviation: 'SD',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+249',
  },
  {
    name: 'Suriname',
    abbreviation: 'SR',
    timezone: 'SA Eastern Standard Time',
    utc: 'UTC-03:00',
    code: '+597',
  },
  {
    name: 'Svalbard',
    abbreviation: 'SJ',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+47',
  },
  {
    name: 'Swaziland',
    abbreviation: 'SZ',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+268',
  },
  {
    name: 'Sweden',
    abbreviation: 'SE',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+46',
  },
  {
    name: 'Switzerland',
    abbreviation: 'CH',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+41',
  },
  {
    name: 'Syria',
    abbreviation: 'SY',
    timezone: 'Syria Standard Time',
    utc: 'UTC+02:00',
    code: '+963',
  },
  {
    name: 'Taiwan',
    abbreviation: 'TW',
    timezone: 'Taipei Standard Time',
    utc: 'UTC+08:00',
    code: '+886',
  },
  {
    name: 'Tajikistan',
    abbreviation: 'TJ',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    code: '+992',
  },
  {
    name: 'Tanzania',
    abbreviation: 'TZ',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+255',
  },
  {
    name: 'Thailand',
    abbreviation: 'TH',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    code: '+66',
  },
  {
    name: 'Togo',
    abbreviation: 'TG',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    code: '+228',
  },
  {
    name: 'Tokelau',
    abbreviation: 'TK',
    timezone: 'Tonga Standard Time',
    utc: 'UTC+13:00',
    code: '+690',
  },
  {
    name: 'Tonga',
    abbreviation: 'TO',
    timezone: 'Tonga Standard Time',
    utc: 'UTC+13:00',
    code: '+676',
  },
  {
    name: 'Trinidad and Tobago',
    abbreviation: 'TT',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-868',
  },
  {
    name: 'Tunisia',
    abbreviation: 'TN',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    code: '+216',
  },
  {
    name: 'Turkey',
    abbreviation: 'TR',
    timezone: 'Turkey Standard Time',
    utc: 'UTC+02:00',
    code: '+90',
  },
  {
    name: 'Turkmenistan',
    abbreviation: 'TM',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    code: '+993',
  },
  {
    name: 'Turks and Caicos Islands',
    abbreviation: 'TC',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    code: '+1-649',
  },
  {
    name: 'Tuvalu',
    abbreviation: 'TV',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    code: '+688',
  },
  {
    name: 'U.S. Minor Outlying Islands',
    abbreviation: 'UM',
    timezone: 'UTC-11',
    utc: 'UTC-11:00',
    code: '+1',
  },
  {
    name: 'Uganda',
    abbreviation: 'UG',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    code: '+256',
  },
  {
    name: 'Ukraine',
    abbreviation: 'UA',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    code: '+380',
  },
  {
    name: 'United Arab Emirates',
    abbreviation: 'AE',
    timezone: 'Arabian Standard Time',
    utc: 'UTC+04:00',
    code: '+971',
  },
  {
    name: 'United Kingdom',
    abbreviation: 'GB',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    code: '+44',
  },
  {
    name: 'Uruguay',
    abbreviation: 'UY',
    timezone: 'Montevideo Standard Time',
    utc: 'UTC-03:00',
    code: '+598',
  },
  {
    name: 'Uzbekistan',
    abbreviation: 'UZ',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    code: '+998',
  },
  {
    name: 'Vanuatu',
    abbreviation: 'VU',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    code: '+678',
  },
  {
    name: 'Vatican City',
    abbreviation: 'VA',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    code: '+379',
  },
  {
    name: 'Vietnam',
    abbreviation: 'VN',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    code: '+84',
  },
  {
    name: 'Virgin Islands, U.S.',
    abbreviation: 'VI',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-340',
  },
  {
    name: 'Virgin Islands, British',
    abbreviation: 'VG',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    code: '+1-284',
  },
  {
    name: 'Wallis and Futuna',
    abbreviation: 'WF',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    code: '+681',
  },
  {
    name: 'Yemen',
    abbreviation: 'YE',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    code: '+967',
  },
  {
    name: 'Zambia',
    abbreviation: 'ZM',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+260',
  },
  {
    name: 'Zimbabwe',
    abbreviation: 'ZW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    code: '+263',
  }
]
